import classNames from 'classnames';
import React from 'react';

import { Typography } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';

import { typograf } from '../../../../utils/typograf';
import { TReviewCardProps } from '../../index';
import styles from '../../review-card.module.scss';

export interface IReviewBody extends Pick<TReviewCardProps, 'review' | 'isMobile'> {
  isList: boolean;
}

export const ReviewBody: React.FC<IReviewBody> = ({ review, isList, isMobile }) => {
  const [showFullText, setShowFullText] = useBoolean(false);

  const handleToggleText = (e) => {
    e.preventDefault();
    setShowFullText.toggle();
  };

  const text = showFullText || !isList ? review.text : review.html;

  const decodedText = text
    ?.replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\\([*])/g, '$1');

  return (
    <>
      <div
        className={isList ? styles.title : styles['title--card']}
        dangerouslySetInnerHTML={{ __html: typograf.execute(review.title) }}
      />
      <div
        className={classNames(styles.text, {
          'h-mt-8 h-mb-8': isList,
          'h-mt-8 h-mb-16': !isList && isMobile,
          'h-mt-16 h-mb-16': !isList && !isMobile,
          [styles['text__in-list']]: isList,
        })}
      >
        <span dangerouslySetInnerHTML={{ __html: typograf.execute(decodedText) }} />
        {review.moreHtml && (
          <Typography.Link onClick={handleToggleText} className={'h-ml-4'}>
            {showFullText ? 'Скрыть' : 'Читать'}
          </Typography.Link>
        )}
      </div>
    </>
  );
};
